import { render } from "./HealthAuthLayout.vue?vue&type=template&id=ac614912&scoped=true"
import script from "./HealthAuthLayout.vue?vue&type=script&lang=js"
export * from "./HealthAuthLayout.vue?vue&type=script&lang=js"

import "./HealthAuthLayout.vue?vue&type=style&index=0&id=ac614912&scoped=true&lang=scss"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac614912"]])

export default __exports__